module.exports = __webpack_public_path__ + "img/4a.5af15bcf.png";